import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const REQUEST_SELF_EMPLOYMENT_PROFILE = 'REQUEST_SELF_EMPLOYMENT_PROFILE'
export const RECEIVE_SELF_EMPLOYMENT_PROFILE = 'RECEIVE_SELF_EMPLOYMENT_PROFILE'
export const SAVE_SELF_EMPLOYMENT_PROFILE = 'SAVE_SELF_EMPLOYMENT_PROFILE'
export const UPDATE_AND_SAVE_SELF_EMPLOYMENT_PROFILE = 'UPDATE_AND_SAVE_SELF_EMPLOYMENT_PROFILE'

export const requestSelfEmploymentProfile = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_SELF_EMPLOYMENT_PROFILE })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/selfemploymentprofiles/${userId}`)
        .then((response) => {
            const data = response?.data || {}
            dispatch(receiveSelfEmploymentProfile({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveSelfEmploymentProfile({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveSelfEmploymentProfile({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveSelfEmploymentProfile = (data) => ({ type: RECEIVE_SELF_EMPLOYMENT_PROFILE, data })

export const updateAndSaveSelfEmploymentProfile = (data, options) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_SELF_EMPLOYMENT_PROFILE })

    dispatch(receiveSelfEmploymentProfile(data))
    return dispatch(saveSelfEmploymentProfile(options))
}

const saveSelfEmploymentProfile =
    ({ hideAlert } = {}) =>
    (dispatch, getState) => {
        dispatch({ type: SAVE_SELF_EMPLOYMENT_PROFILE })

        const { profile, selfEmploymentProfile } = getState()

        const { id: userId } = profile

        return axios
            .put(`/selfemploymentprofiles/${userId}`, { ...selfEmploymentProfile, userId })
            .then((response) => {
                dispatch(receiveSelfEmploymentProfile(response.data))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert('Datos de autónomo actualizados'))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }
